import { Box } from "@mui/material";
// import logo from "src/assets/1house-logo-horizontal.png";
import useGetLogo from "src/components/logo/hooks/use-logo.js"

const Header = () => {
    const logo = useGetLogo();
    if (!logo) {
    return null; 
  }
  return (
    <Box
      component="header"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        px: { xs: 2, md: 4, lg: 6 },
        py: 1,
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            component="img"
            src={logo}
            alt="1House"
            sx={{ height: { xs: 24, md: 28, lg: 32 }, width: "auto", objectFit: "contain" ,ml:{md:14}}}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
